import {put} from '../utils'

export default host => (id, photoId) =>
  put(`${host}/people/${id}/mainImage`, JSON.stringify({image_id: photoId}))
    .then(response => response.json())
